var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGoldHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1310,
    height: 784,
    viewBox: "0 0 1310 784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1232.81 767.451C1223.02 768.085 1213.24 768.718 1202.2 769.05C1200.16 768.564 1199.35 768.17 1198.58 768.228C1172.07 770.193 1145.6 772.713 1119.06 774.084C1078.65 776.173 1038.21 777.739 997.765 779.022C963.814 780.098 929.836 780.29 895.88 781.223C885.137 781.518 874.425 782.939 863.698 783.845C863.698 783.845 863.207 784.112 862.152 783.861C844.049 783.699 827 783.787 809.397 783.562C800.503 783.505 792.164 783.762 783.06 783.988C693.966 783.976 605.637 784.01 517.309 783.997C504.264 783.994 491.218 783.88 478.176 783.626C433.11 782.75 388.044 781.789 342.258 780.787C321.467 779.768 301.4 778.737 281.325 777.894C250.659 776.607 219.985 775.534 189.322 774.196C176.037 773.616 162.774 772.568 149.498 771.795C125.662 770.406 101.823 769.063 77.9856 767.701C77.9856 767.701 77.4501 767.812 76.7472 767.246C50.7903 762.053 25.5364 757.426 0.282419 752.799C0.182467 750.93 0.0825133 749.061 0 747.519C6.22105 745.498 12.1886 743.559 19.2567 741.89C26.219 741.362 32.0667 740.436 37.945 739.789C59.6845 737.395 81.4627 735.327 103.17 732.675C117.962 730.868 117.92 730.524 117.671 715.316C120.071 699.641 122.363 683.948 124.901 668.295C127.821 650.293 131.001 632.332 133.982 614.339C135.197 607.003 136.129 599.62 137.338 592.283C137.536 591.079 138.284 589.783 139.154 588.898C148.377 579.513 157.015 569.403 167.115 561.064C181.388 549.281 189.672 533.261 199.631 518.491C213.91 497.315 222.879 473.478 231.947 449.708C242.942 420.889 254.466 392.263 266.259 363.76C272.914 347.674 280.572 332.001 288.406 314.759C279.546 318.035 271.064 320.708 262.961 324.249C233.129 337.288 208.482 357.265 188.865 382.945C175.77 400.088 165.078 419.059 152.031 436.242C140.68 451.192 129.612 467.563 109.962 472.861C84.6936 479.675 59.5509 481.485 36.1327 466.062C24.8022 458.6 18.7801 441.456 20.1825 428.375C21.4929 416.154 27.3713 409.453 37.0377 402.746C42.2882 399.103 43.5546 389.73 47.4768 381.038C55.984 378.191 64.6082 385.345 65.7285 398.389C66.8116 411.001 62.8366 420.751 53.0776 428.825C48.6896 432.456 42.641 436.244 45.6197 443.834C48.8205 451.989 55.479 454.325 63.2916 452.698C76.2094 450.008 88.9787 446.607 102.861 443.173C104.705 442.355 105.499 441.87 106.294 441.385C106.294 441.385 106.219 441.557 106.59 441.413C107.253 440.753 107.544 440.238 107.836 439.722C107.836 439.722 107.843 439.836 108.284 439.835C109.098 439.329 109.47 438.824 109.842 438.319C109.842 438.319 110.141 438.079 110.906 438.288C112.871 438.662 114.072 438.827 117.857 439.348C111.366 443.629 106.702 446.533 102.275 449.761C101.323 450.456 101.225 452.321 100.734 453.647C102.084 453.9 103.897 454.845 104.711 454.3C111.813 449.548 120.621 446.814 125.168 438.141C126.328 436.503 126.841 434.872 127.371 433.335C127.389 433.428 127.204 433.467 127.204 433.467C131.838 431.751 139.095 423.512 141.617 414.697C149.521 387.079 168.006 367.232 190.095 350.981C209.405 336.775 230.538 325.033 250.945 312.329C253.826 310.535 257.153 309.457 261.314 307.711C263.17 306.468 263.985 305.562 264.799 304.655C264.799 304.655 265.221 304.384 266.139 304.544C283.568 298.763 300.079 292.822 316.59 286.881C320.68 285.801 324.77 284.722 329.7 283.653C330.882 283.485 331.237 283.326 331.606 283.187C331.606 283.187 331.553 283.302 332.225 283.288C355.601 282.162 378.298 280.435 401.013 280.163C415.308 279.991 429.63 282.001 444.947 283.105C437.304 286.138 431.015 288.634 424.726 291.129C395.295 299.321 367.13 310.064 343.804 330.746C342.119 332.24 339.641 332.84 336.77 334.232C335.741 335.06 335.353 335.349 334.844 335.478C334.597 335.976 334.35 336.474 333.429 337.38C332.352 338.16 331.948 338.531 331.545 338.903C330.856 339.844 330.167 340.785 328.589 342.006C327.36 342.785 327.021 343.285 326.682 343.785C326.682 343.785 326.688 343.666 326.286 343.754C325.612 344.367 325.341 344.893 325.07 345.419C325.07 345.419 325.06 345.305 324.633 345.353C323.954 345.95 323.702 346.5 323.45 347.05C323.45 347.05 323.428 346.938 322.999 346.982C322.32 347.578 322.07 348.13 321.819 348.682C321.819 348.682 321.796 348.569 321.365 348.611C320.686 349.206 320.437 349.76 320.189 350.313C320.189 350.313 320.164 350.201 319.733 350.24C319.053 350.835 318.805 351.39 318.557 351.944C318.557 351.944 318.522 351.826 317.998 351.752C314.492 354.661 311.511 357.645 308.53 360.629C309.062 361.241 309.595 361.853 310.127 362.465C315.075 360.021 320.023 357.578 324.972 355.135C329.365 353.202 333.759 351.269 339.438 349.088C357.088 348.116 373.452 346.934 389.82 346.882C396.994 346.859 404.175 349.144 411.353 350.381C414.506 351.324 417.66 352.267 423.612 354.047C324.285 406.45 244.822 476.585 191.641 575.105C194.63 576.498 196.628 577.429 200.062 579.029C172.704 597.268 151.613 619.456 142.868 651.709C147.879 649.17 152.497 646.83 157.116 644.489C147.059 666.647 148.133 687.63 155.835 710.767C158.978 706.988 160.763 704.841 161.786 703.61C167.318 711.196 172.852 718.791 178.401 726.376C178.718 726.81 179.137 727.175 179.535 727.544C187.704 735.108 191.179 734.778 198.731 725.504C200.165 727.487 201.503 729.44 202.947 731.31C204.355 733.132 205.872 734.871 207.362 736.673C212.394 730.986 211.886 724.759 205.828 713.989C207.555 711.404 209.262 710.066 210.933 708.758C210.896 708.788 210.87 708.697 210.851 709.276C214.489 712.925 218.146 715.997 222.388 719.128C223.307 718.982 223.641 718.776 223.96 718.585C223.945 718.601 223.948 718.644 223.68 719.177C223.556 720.487 223.699 721.264 223.615 722.42C226.411 727.198 229.955 727.919 234.811 724.277C239.774 724.095 244.038 723.949 249.066 723.832C290.135 722.668 330.439 721.48 370.742 720.263C372.341 720.215 373.93 719.89 375.524 719.693C374.931 718.322 374.338 716.951 373.835 715.519C373.925 715.457 374.052 715.633 373.817 715.366C373.398 714.645 373.102 714.284 372.452 713.501C359.36 697.416 345.911 682.291 333.832 666.145C322.645 651.19 319.378 633.732 321.577 615.097C322.712 605.482 322.674 595.728 323.218 585.023C317.41 588.794 312.892 592.691 307.663 594.939C292.99 601.246 278.024 606.873 262.508 612.734C256.433 614.261 250.908 615.515 245.647 617.477C240.842 619.269 236.323 621.828 231.489 624.173C231.299 624.298 230.871 624.147 230.225 624.075C227.664 625.213 225.748 626.423 223.831 627.564C223.829 627.495 223.967 627.499 223.483 627.507C222.63 628.003 222.261 628.491 221.709 629.099C221.526 629.22 221.118 629.059 220.609 629.16C219.617 629.701 219.135 630.141 218.447 630.703C218.242 630.825 217.787 630.68 217.176 630.636C214.622 631.782 212.68 632.972 210.556 634.686C203.512 639.85 197.701 645.322 195.144 653.998C193.577 659.1 191.996 663.934 191.594 668.863C191.065 675.342 191.464 681.897 191.464 688.419C190.201 688.533 188.938 688.648 187.675 688.762C186.547 682.413 185.51 676.046 184.252 669.722C183.618 666.536 182.584 663.429 181.731 660.286C180.901 652.37 184.151 646.091 188.997 640.045C209.803 614.086 231.207 588.543 250.75 561.655C264.222 543.119 274.991 522.624 286.995 503.02C288.195 501.061 289.577 499.214 291.866 497.603C296.58 518.4 291.526 538.104 286.371 558.138C326.614 518.796 361.944 475.677 390.858 427.416C395.584 442.415 386.998 482.409 370.315 524.597C369.86 526.021 369.551 526.321 369.015 526.389C369.015 526.389 369.101 526.196 368.711 526.558C368.074 528.391 367.826 529.864 367.579 531.336C367.579 531.336 367.518 531.234 367.031 531.363C364.877 534.639 363.211 537.786 361.545 540.932C362.338 541.362 363.131 541.791 363.923 542.221C365.611 539.528 367.3 536.835 368.988 534.142C368.988 534.142 369.116 534.293 369.526 534.321C370.187 533.797 370.437 533.246 370.688 532.695C370.688 532.695 370.716 532.811 371.262 532.885C373.055 531.242 374.302 529.526 375.549 527.81C375.549 527.81 375.614 527.919 376.058 527.901C376.736 527.31 376.969 526.738 377.201 526.166C377.201 526.166 377.238 526.28 377.686 526.27C378.368 525.685 378.603 525.11 378.837 524.535C378.837 524.535 378.871 524.649 379.319 524.635C380 524.048 380.234 523.475 380.467 522.902C380.467 522.902 380.502 523.017 380.95 523.005C381.633 522.419 381.866 521.845 382.1 521.271C382.1 521.271 382.135 521.386 382.583 521.374C383.265 520.788 383.499 520.214 383.733 519.64C383.733 519.64 383.767 519.755 384.216 519.743C384.898 519.158 385.133 518.584 385.367 518.01C385.367 518.01 385.401 518.124 385.843 518.107C386.526 517.52 386.767 516.951 387.008 516.382C387.008 516.382 387.035 516.495 387.47 516.464C388.153 515.873 388.4 515.313 388.647 514.753C388.647 514.753 388.669 514.865 389.095 514.817C389.776 514.22 390.031 513.671 390.287 513.122C390.287 513.122 390.303 513.237 390.725 513.135C391.423 512.453 391.699 511.872 391.975 511.292C391.932 510.74 392.155 510.335 393.318 509.734C394.41 509.005 394.83 508.617 395.249 508.228C395.249 508.228 395.219 508.366 395.63 508.19C396.86 507.026 397.68 506.038 398.5 505.05C398.5 505.05 398.521 505.143 398.645 504.779C399.128 503.994 399.569 503.695 400.093 503.518C414.66 484.335 429.307 465.213 443.725 445.92C446.609 442.061 448.617 437.549 452.255 431.197C458.169 447.382 459.916 463.16 473.396 475.874C475.369 469.567 477.617 464.644 478.324 459.509C479.082 454.006 480.056 452.418 485.599 455.518C494.555 460.524 503.968 464.715 514.182 469.833C524.969 472.185 534.698 474.869 544.566 475.549C570.7 477.349 596.299 473.072 621.533 466.613C625.811 465.518 629.738 463.053 633.827 461.221C633.827 461.221 634.245 460.968 635.134 461.143C638.458 460.703 640.893 460.09 643.328 459.476C650.556 456.317 657.785 453.159 665.913 450.077C668.256 449.394 669.699 448.636 671.142 447.878C671.142 447.878 671.014 448.034 671.524 448.122C674.1 447.269 676.167 446.327 678.768 445.142C666.551 443.835 655.667 442.67 644.782 441.505C638.654 438.307 632.527 435.108 625.618 431.392C624.391 430.688 624.013 430.408 623.706 430.033C623.706 430.033 623.861 430.118 623.784 429.614C622.952 427.489 622.195 425.868 620.997 423.3C624.292 423.3 626.648 423.351 629.001 423.292C647.956 422.818 667.061 423.615 685.822 421.447C702.329 419.539 718.451 414.306 734.742 410.542C752.071 401.845 769.596 393.51 786.631 384.274C793.503 380.548 799.302 374.848 806.399 369.926C807.587 369.203 807.965 368.598 808.342 367.994C808.235 367.423 808.426 366.978 809.911 366.585C815.356 365.433 815.865 367.237 815.026 371.24C813.447 378.773 812.439 386.425 811.194 394.028C811.486 408.664 811.778 423.3 812.07 437.936C813.04 438.144 814.01 438.353 814.979 438.562C849.843 407.43 868.575 365.048 891.164 325.356C891.849 325.566 892.533 325.775 893.218 325.985C893.218 337.502 894.111 349.109 892.975 360.514C891.749 372.833 889.431 385.185 886.145 397.126C880.935 416.053 871.025 432.66 859.495 448.629C843.129 471.296 828.053 494.891 812.4 518.072C812.124 518.481 811.528 518.674 809.876 519.762C808.483 512.772 807.193 506.301 805.959 500.106C796.553 507.76 777.739 574.208 775.246 599.133C771.695 634.65 776.912 669.031 785.446 703.373C784.686 703.52 783.926 703.667 783.166 703.814C780.468 701.417 777.769 699.019 775.071 696.622C774.225 696.881 773.38 697.14 772.535 697.399C774.506 707.324 776.478 717.248 778.75 728.321C786.635 737.837 813.308 743.367 823.605 738.623C824.14 738.376 824.279 737.27 824.603 736.564C824.603 736.564 824.611 736.679 825.058 736.665C825.738 736.079 825.971 735.509 826.204 734.938C826.204 734.938 826.239 735.052 826.687 735.039C827.369 734.453 827.603 733.88 827.838 733.307C827.838 733.307 827.872 733.421 828.314 733.405C828.999 732.819 829.243 732.25 829.487 731.68C829.487 731.68 829.469 731.797 830.109 731.786C832.593 731.77 834.436 731.764 836.279 731.758C836.279 731.758 836.157 731.763 836.073 732.235C836.608 733.505 837.227 734.304 837.846 735.103C837.846 735.103 837.717 735.064 837.723 735.609C839.423 737.39 841.117 738.624 842.811 739.859C842.811 739.859 842.677 739.97 843.032 740.42C847.262 740.998 851.195 741.584 854.993 741.104C857.993 740.725 857.953 739.644 855.308 736.861C855.308 736.861 855.457 736.72 855.53 736.291C855.03 735.626 854.457 735.39 853.884 735.155C853.884 735.155 853.997 735.124 853.967 734.691C853.376 734.008 852.816 733.757 852.255 733.506C852.255 733.506 852.368 733.488 852.317 733.063C851.717 732.383 851.168 732.127 850.619 731.871C850.619 731.871 850.736 731.849 850.586 731.389C849.952 730.394 849.468 729.858 848.984 729.323C837.475 720.112 825.966 710.902 814.521 701.743C814.154 703.398 813.401 706.784 812.678 710.035C801.475 693.783 799.55 651.642 823.301 618.197C824.207 616.982 824.4 616.43 824.593 615.878C824.593 615.878 824.587 615.995 825.099 615.925C826.35 614.233 827.088 612.611 827.826 610.989C827.826 610.989 827.851 611.104 828.358 611.038C830.161 608.909 831.457 606.845 832.752 604.78C832.016 603.889 831.281 602.997 830.545 602.106C827.499 604.081 824.454 606.056 821.408 608.032C821.408 608.032 821.401 607.905 820.987 607.962C820.313 608.562 820.054 609.104 819.794 609.646C819.794 609.646 819.777 609.533 819.336 609.56C818.656 610.152 818.416 610.715 818.177 611.279C818.177 611.279 818.137 611.157 817.664 611.071C816.409 611.645 815.628 612.305 814.847 612.965C811.582 617.285 808.316 621.604 805.051 625.924C804.44 625.924 803.83 625.924 803.22 625.924C803.22 622.655 802.219 618.963 803.396 616.192C808.055 605.214 812.557 594.018 818.698 583.856C826.318 571.246 834.838 559.028 844.247 547.7C850.502 540.171 858.317 533.431 866.603 528.179C900.7 506.571 920.777 474.825 934.082 437.894C937.915 427.254 941.55 416.543 945.382 405.903C946.064 404.009 947.27 402.303 949.227 400.872C951.005 434.809 946.159 467.895 941.268 501.743C952.816 497.972 960.181 488.833 967.267 480.356C974.427 471.792 979.394 461.4 986.339 450.162C986.339 466.054 985.693 480.269 986.504 494.401C987.5 511.745 989.045 529.118 991.57 546.3C994.625 567.083 998.639 587.741 1002.81 608.337C1007.62 632.048 1013.05 655.632 1018.24 679.266C1019.07 683.054 1019.84 686.869 1020.96 690.575C1023.4 698.626 1030.17 701.626 1038.3 704.685C1040.88 705.432 1042.46 705.593 1044.05 705.753C1044.05 705.753 1044.43 705.583 1044.82 706.179C1045.89 706.978 1046.55 707.182 1047.21 707.386C1047.21 707.386 1047.67 707.251 1048.04 707.934C1053.32 710.343 1058.24 712.068 1063.16 713.794C1063.16 713.794 1063.05 713.852 1063.14 714.387C1065.41 715.619 1067.59 716.316 1069.77 717.013C1069.77 717.013 1069.67 717.098 1069.69 717.457C1070.14 718.14 1070.56 718.465 1070.98 718.789C1070.98 718.789 1071.22 719.437 1071.31 720.263C1071.93 721.387 1072.45 721.686 1072.97 721.984C1072.97 721.984 1072.85 721.995 1072.9 722.6C1075.99 723.871 1079.01 724.949 1082.09 725.136C1107.27 726.666 1132.47 727.764 1157.63 729.511C1188.2 731.634 1218.73 734.262 1249.27 736.671C1250.53 736.689 1251.79 736.707 1254.21 737.169C1268.55 739.589 1281.73 741.565 1295.45 743.497C1296.34 743.392 1296.69 743.329 1297.04 743.266C1297.04 743.266 1297.51 743.134 1298.06 743.719C1299.71 744.506 1300.81 744.709 1301.91 744.911C1301.91 744.911 1302.39 744.778 1302.9 745.35C1304.43 746.084 1305.44 746.246 1306.44 746.409C1306.44 746.409 1306.35 746.493 1306.32 747.091C1304.42 750.091 1303.03 753.635 1300.58 754.676C1294.01 757.465 1286.99 759.182 1280.15 761.325C1280.15 761.325 1280.2 761.211 1279.52 761.076C1263.49 763.111 1248.15 765.281 1232.81 767.451ZM964.699 716.467C964.2 716.155 963.701 715.844 963.374 715.545C963.374 715.545 963.354 715.717 963.315 714.64C962.383 713.328 961.451 712.017 959.971 709.667C958.899 708.167 957.694 706.743 956.775 705.154C949.095 691.884 941.449 678.595 933.831 665.289C928.358 655.729 920.862 646.719 917.969 636.425C913.086 619.049 910.044 600.949 908.434 582.956C907.676 574.491 912.043 565.569 914.177 556.474C913.446 556.699 912.289 556.878 911.299 557.384C898.552 563.906 885.548 569.995 873.21 577.219C866.389 581.212 859.011 586.012 854.792 592.373C838.836 616.432 821.723 639.883 817.745 670.126C816.445 680.007 818.134 687.401 823.834 693.987C830.541 701.735 838.501 708.4 846.822 716.376C849.886 717.116 852.937 718.425 856.017 718.498C870.516 718.844 885.024 718.85 900 719.342C900.548 719.243 901.096 719.144 903.094 719.119C907.019 719.016 910.944 718.913 915.459 718.721C915.459 718.721 915.999 718.976 917.116 719.761C931.976 719.998 946.836 720.275 961.697 720.391C962.818 720.399 963.949 719.253 965.068 718.788C965.068 718.788 964.924 718.783 965.418 718.45C965.255 718.006 965.091 717.562 965.076 717.142C965.076 717.142 965.054 717.291 964.699 716.467ZM462.209 611.166C462.209 611.166 462.322 611.21 461.335 611.125C460.961 611.634 460.587 612.142 459.88 612.89C459.88 612.89 459.506 612.723 458.249 612.566C456.857 613.786 455.464 615.006 454.038 616.113C454.038 616.113 454.156 616.107 452.986 615.911C451.719 617.099 450.452 618.287 449.141 619.366C449.141 619.366 449.257 619.352 448.282 619.312C447.907 619.809 447.532 620.306 446.813 621.043C446.813 621.043 446.427 620.878 445.122 620.76C439.916 623.63 434.71 626.501 429.145 630.285C428.192 630.451 427.24 630.616 425.818 630.648C425.473 631.091 425.128 631.533 423.726 632.511C422.17 633.516 420.699 634.7 419.042 635.494C410.853 639.419 408.755 645.106 413.256 653.258C415.652 657.598 417.459 662.263 419.893 667.603C420.43 667.787 420.967 667.97 421.391 668.182C421.391 668.182 421.418 668.069 421.45 669.058C422.013 669.3 422.577 669.542 423.027 669.812C423.027 669.812 423.057 669.699 423.056 670.711C423.631 670.941 424.205 671.17 424.663 671.439C424.663 671.439 424.702 671.323 424.666 672.344C425.248 672.573 425.83 672.801 426.296 673.07C426.296 673.07 426.336 672.953 426.299 673.974C426.881 674.203 427.463 674.432 427.928 674.701C427.928 674.701 427.968 674.584 427.933 675.602C428.513 675.835 429.092 676.067 429.559 676.334C429.559 676.334 429.587 676.22 429.613 677.2C430.176 677.45 430.739 677.7 431.189 677.968C431.189 677.968 431.208 677.855 431.27 678.831C431.826 679.081 432.382 679.332 432.8 679.532C432.8 679.532 432.857 679.397 432.938 680.568C434.574 681.31 436.209 682.052 437.724 682.8C437.724 682.8 437.751 682.682 437.847 683.901C439.617 684.657 441.388 685.413 443.551 686.012C443.551 686.012 443.899 686.254 444.198 687.197C444.794 687.372 445.389 687.548 445.876 687.759C445.876 687.759 445.901 687.648 445.955 688.517C446.385 688.89 446.815 689.264 447.953 690.585C455.719 694.582 464.006 697.856 471.02 702.897C474.254 705.222 475 711.002 477.606 716.437C480.796 716.769 483.987 717.392 487.177 717.391C575.686 717.372 664.195 717.305 752.703 717.138C755.464 717.132 758.223 715.977 760.963 715.516C760.963 715.516 760.805 715.494 761.964 715.075C761.751 711.987 761.537 708.9 760.593 704.661C760.114 703.761 759.352 702.906 759.197 701.953C757.018 688.629 755.678 675.115 752.604 662.005C749.155 647.299 741.959 633.343 746.07 617.001C746.111 598.188 746.152 579.375 744.947 559.901C746.283 541.44 739.562 524.663 733.724 505.085C732.745 509.935 732.304 512.397 731.747 514.832C728.894 527.302 726.011 539.765 721.834 552.493C696.767 553.315 671.703 554.328 646.63 554.871C635.672 555.109 624.693 554.385 612.426 554.09C610.711 553.951 608.996 553.812 606.782 552.645C591.775 550.41 576.769 548.176 560.43 545.903C558.665 545.782 556.901 545.661 554.684 544.514C542.431 540.948 530.185 537.359 517.896 533.927C517.543 533.828 516.726 535.389 516.087 537.436C507.47 565.745 491.646 588.962 466.47 606.51C466.136 607.012 465.802 607.513 465.472 607.899C465.472 607.899 465.587 607.917 464.612 607.985C464.363 608.538 464.114 609.092 463.843 609.533C463.843 609.533 463.956 609.556 462.966 609.6C462.725 610.161 462.485 610.721 462.209 611.166ZM254.775 431.625C254.775 431.625 254.967 431.656 254.053 432.462C253.75 434.022 253.447 435.581 253.288 437.587C253.288 437.587 253.039 437.985 252.019 438.58C250.648 442.276 249.277 445.973 247.906 449.67C248.859 450.052 249.812 450.434 250.766 450.816C252.081 447.621 253.397 444.426 254.806 441.376C254.806 441.376 254.658 441.464 255.787 441.3C257.076 438.6 258.365 435.901 259.699 433.319C259.699 433.319 259.58 433.361 260.548 432.861C260.811 431.848 261.074 430.834 261.777 428.772C274.631 404.859 282.946 379.466 287.195 352.745C286.52 352.493 285.846 352.24 285.171 351.988C275.482 378.084 265.793 404.18 255.65 430.812C255.55 431.334 255.243 431.668 254.775 431.625ZM45.1191 407.452C42.6966 409.025 40.2607 410.579 37.8546 412.177C33.9052 414.8 29.4608 417.193 32.1256 423.802C38.4553 418.998 44.831 414.854 50.2586 409.712C52.5784 407.514 52.9213 403.234 54.1624 399.9C53.4848 399.737 52.8072 399.575 52.1295 399.412C50.0798 401.814 48.03 404.215 45.1191 407.452ZM151.335 595.148C157.707 597.361 167.311 591.15 170.725 581.947C162.007 583.066 156.4 587.807 151.335 595.148Z",
    fill: "url(#paint0_linear_477_18467)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M823.059 73.1459C833.03 63.8551 843.936 56.2558 857.307 52.4052C869.819 48.8018 882.137 44.5224 895.075 40.3692C893.577 38.655 892.219 37.0998 890.083 35.0403C888.867 34.3504 888.501 34.0694 888.208 33.6929C888.208 33.6929 888.362 33.8018 888.363 33.2932C888.953 30.9834 889.542 29.1823 890.131 27.3812C890.131 27.3812 890.563 27.1151 891.535 27.2706C924.029 20.3967 955.767 15.4676 988.24 17.0359C989.698 17.1064 991.264 14.9625 992.779 13.8501C992.779 13.8501 992.788 13.0687 993.02 12.5496C993.399 11.7475 993.375 11.4328 993.18 11.0866C991.736 7.6093 990.293 4.13202 988.577 0C1030.03 3.00999 1095.38 65.955 1085.13 92.9359C1067.93 72.4916 1045.82 59.3108 1022.38 46.1949C1011.32 42.0709 1001 38.7085 990.676 35.346C990.676 35.346 990.171 35.4616 989.601 34.829C985.36 33.3876 981.688 32.5788 978.016 31.77C977.684 32.6426 977.352 33.5154 977.021 34.388C978.597 35.212 980.173 36.0359 981.749 36.8599C981.749 36.8599 981.627 36.9958 981.414 37.5372C982.417 39.8834 983.632 41.6882 984.847 43.4931C984.847 43.4931 984.713 43.5142 984.736 43.9219C985.236 44.7005 985.713 45.0715 986.19 45.4425C986.19 45.4425 986.426 45.7944 986.206 46.6667C986.245 51.2713 985.971 54.2734 980.774 52.5404C978.774 51.8732 976.531 51.932 974.398 51.66C974.398 51.66 973.846 51.763 973.418 51.2743C972.604 50.3886 972.134 50.1626 970.999 49.8422C966.465 48.7877 962.437 47.0655 958.58 47.3879C947.619 48.3038 936.729 50.054 925.81 51.4758C912.662 55.9018 899.514 60.3278 885.241 64.8093C883.338 65.4128 882.56 65.9607 881.783 66.5086C881.783 66.5086 881.814 66.3843 881.4 66.4274C880.608 66.9473 880.231 67.4243 879.854 67.9013C879.854 67.9013 879.506 68.1367 878.664 67.9762C874.98 69.1107 872.14 70.4059 869.299 71.701C878.628 74.363 887.314 74.8039 895.895 75.9956C897.94 76.2797 899.637 79.0723 901.494 80.7111C895.409 82.9921 889.324 85.2732 882.167 87.6503C880.706 88.1882 880.316 88.6298 879.925 89.0716C879.925 89.0716 879.503 89.3221 878.77 89.3762C877.563 89.8625 877.088 90.2946 876.613 90.7265C876.613 90.7265 876.26 90.9749 875.465 90.8502C873.776 91.3554 872.883 91.9853 871.99 92.6152C871.99 92.6152 872.022 92.5042 871.477 92.3767C869.015 93.3632 867.097 94.4772 865.18 95.5913C865.18 95.5913 864.808 95.8412 863.948 95.6686C861.172 96.7109 859.257 97.9256 857.341 99.1403C857.341 99.1403 857.326 99.0267 856.883 99.0206C856.065 99.5226 855.69 100.03 855.315 100.538C855.315 100.538 855.018 100.777 854.319 100.783C853.124 101.243 852.627 101.697 852.13 102.151C852.13 102.151 851.774 102.394 851.043 102.379C849.828 102.832 849.346 103.299 848.863 103.766C848.863 103.766 848.48 104.003 847.738 104.024C846.637 104.588 846.278 105.13 845.919 105.672C845.919 105.672 845.908 105.547 845.421 105.428C844.163 105.972 843.392 106.634 842.62 107.297C842.62 107.297 842.631 107.177 842.204 107.221C841.528 107.818 841.278 108.371 841.028 108.923C841.028 108.923 840.998 108.805 840.521 108.731C839.255 109.321 838.466 109.985 837.677 110.649C837.738 111.236 837.508 111.667 836.104 112.141C834.414 113.378 833.607 114.417 832.8 115.456C832.8 115.456 832.801 115.287 832.38 115.488C831.404 116.15 830.848 116.61 830.292 117.07C822.312 129.895 814.332 142.719 805.321 156.073C803.994 157.696 803.698 158.788 803.403 159.881C803.403 159.881 803.538 160.329 802.979 160.773C802.215 161.846 802.01 162.476 801.865 163.334C801.925 163.562 801.693 163.972 801.137 164.045C799.415 166.335 798.249 168.554 797.083 170.772C797.815 171.292 798.547 171.813 799.279 172.333C803.899 167.916 808.519 163.499 813.14 159.082C813.14 159.082 813.157 159.23 813.672 159.317C815.474 158.221 816.761 157.037 818.048 155.853C818.048 155.853 818.088 155.967 818.74 156.056C822.238 156.116 825.082 156.089 827.927 156.061C817.817 170.249 808.383 184.985 797.411 198.473C786.073 212.411 773.242 225.135 760.388 239.075C759.043 240.732 758.374 241.705 757.704 242.678C757.704 242.678 757.719 242.526 757.228 242.595C755.454 244.326 754.17 245.989 752.887 247.653C752.887 247.653 752.805 247.512 752.433 247.583C751.773 248.165 751.485 248.676 751.197 249.186C751.197 249.186 751.198 249.068 750.803 249.162C750.129 249.778 749.85 250.298 749.571 250.819C749.571 250.819 749.567 250.703 749.167 250.791C748.492 251.402 748.218 251.926 747.944 252.449C747.944 252.449 747.937 252.335 747.52 252.398C746.843 253.001 746.582 253.541 746.322 254.081C746.322 254.081 746.304 253.968 745.875 254.015C745.197 254.612 744.949 255.163 744.7 255.713C744.7 255.713 744.673 255.601 744.235 255.634C743.557 256.226 743.316 256.786 743.075 257.346C743.075 257.346 743.041 257.232 742.598 257.254C741.919 257.843 741.682 258.41 741.445 258.977C741.445 258.977 741.4 258.851 740.866 258.752C738.529 260.427 736.726 262.202 734.923 263.976C734.923 263.976 734.843 263.829 734.459 263.881C733.801 264.455 733.527 264.977 733.253 265.499C733.253 265.499 733.241 265.384 732.807 265.491C732.104 266.2 731.836 266.802 731.568 267.405C730.836 267.826 730.103 268.248 728.641 268.984C727.505 269.676 727.098 270.055 726.691 270.434C726.78 271.029 726.565 271.477 725.395 272.095C724.261 272.531 723.865 272.79 723.558 273.184C716.473 278.639 709.388 284.093 701.907 289.852C703.074 292.629 704.278 295.495 705.419 299.611C702.658 301.289 699.955 302.111 697.264 302.075C688.916 301.964 680.573 301.527 672.228 301.216C672.228 301.216 671.755 301.356 671.112 300.755C667.303 299.51 664.161 298.478 660.967 298.283C630.451 296.42 599.924 294.727 569.404 292.919C560.479 292.39 551.565 291.652 541.42 290.922C544.684 289.819 546.662 289.151 548.64 288.482C549.98 287.918 551.32 287.354 553.685 287.132C572.285 283.378 589.86 279.283 607.434 275.188C620.984 271.133 634.715 267.593 648.04 262.902C668.434 255.721 688.547 247.746 709.952 239.848C715.74 236.68 720.357 233.771 724.973 230.863C724.973 230.863 725.034 230.996 725.434 230.996C726.203 230.528 726.574 230.059 726.944 229.591C726.944 229.591 727.335 229.346 728.049 229.271C729.146 228.693 729.527 228.189 729.909 227.685C729.909 227.685 729.911 227.8 730.347 227.834C731.152 227.356 731.521 226.844 731.89 226.333C731.89 226.333 732.273 226.095 733.109 226.214C735.313 225.126 736.681 223.919 738.05 222.712C738.05 222.712 738.107 222.859 738.501 222.812C739.162 222.232 739.429 221.699 739.696 221.166C739.696 221.166 739.709 221.28 740.125 221.264C740.906 220.769 741.271 220.29 741.636 219.81C741.636 219.81 742.067 219.569 742.876 219.574C744.862 218.486 746.038 217.393 747.756 215.797C738.271 213.684 729.957 211.832 721.644 209.98C721.644 209.98 721.748 209.933 721.6 209.512C720.846 208.809 720.24 208.528 719.634 208.247C719.634 208.247 719.207 208.386 718.856 207.796C717.914 207.047 717.324 206.887 716.734 206.727C716.734 206.727 716.849 206.671 716.84 206.225C716.254 205.545 715.677 205.309 715.1 205.074C715.1 205.074 715.213 205.041 715.193 204.597C714.603 203.917 714.033 203.681 713.464 203.445C713.464 203.445 713.579 203.409 713.585 202.98C713.091 202.184 712.59 201.817 712.09 201.451C712.09 201.451 711.85 201.105 712.006 200.313C712.071 199.13 711.98 198.738 711.89 198.347C711.89 198.347 711.978 198.47 712.422 198.576C714.158 198.193 715.45 197.702 716.742 197.212C718.574 196.125 720.407 195.038 723.361 193.77C727.911 191.349 731.34 189.11 734.769 186.871C734.769 186.871 734.817 186.978 735.252 187.006C736.063 186.533 736.44 186.032 736.817 185.532C736.817 185.532 737.134 185.29 737.948 185.455C740.155 184.409 741.548 183.199 742.941 181.989C742.941 181.989 742.982 182.1 743.412 182.141C744.21 181.674 744.577 181.165 744.944 180.656C744.944 180.656 745.307 180.419 746.064 180.556C747.747 180.176 748.672 179.657 749.597 179.139C774.808 163.602 795.347 143.856 807.068 116.02C808.782 111.949 811.376 108.248 814.557 103.874C815.82 102.389 816.09 101.405 816.36 100.42C816.36 100.42 816.362 100.553 816.884 100.517C818.154 98.8472 818.903 97.2126 819.652 95.5781C819.652 95.5781 819.712 95.6779 820.117 95.6088C820.798 95.0083 821.074 94.4767 821.35 93.9452C821.35 93.9452 821.311 94.091 821.817 93.9998C823.061 92.2933 823.8 90.678 824.539 89.0627C824.539 89.0627 824.615 89.1733 825.055 89.1562C825.733 88.5668 825.971 87.9944 826.209 87.4221C826.209 87.4221 826.239 87.5349 826.671 87.4995C827.354 86.9078 827.605 86.3514 827.856 85.795C827.856 85.795 827.875 85.9076 828.295 85.8499C828.976 85.25 829.237 84.7079 829.498 84.1659C829.498 84.1659 829.511 84.2791 829.927 84.2166C830.607 83.6143 830.871 83.0746 831.135 82.535C831.135 82.535 831.146 82.649 831.556 82.5758C832.233 81.9683 832.501 81.4342 832.768 80.9001C832.768 80.9001 832.656 81.0581 833.121 81.0487C834.446 79.7512 835.307 78.4632 836.167 77.1752C833.882 77.868 831.596 78.5608 829.31 79.2536C829.31 79.2536 828.905 79.5151 827.977 79.3394C824.574 78.102 822.099 77.0401 819.625 75.9782C819.625 75.9782 819.634 76.1011 820.087 76.0971C821.38 75.1107 822.219 74.1283 823.059 73.1459Z",
    fill: "url(#paint1_linear_477_18467)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.72 154.244C1149.33 153.782 1148.94 153.32 1147.88 152.424C1146.73 151.864 1146.39 151.569 1146.2 151.105C1146.2 151.105 1146.38 151.172 1146.07 150.736C1144.62 150.041 1143.49 149.782 1142.36 149.523C1142.36 149.523 1142.03 149.707 1141.73 149.111C1140.83 148.339 1140.22 148.162 1139.62 147.985C1139.62 147.985 1139.73 148.003 1139.69 147.461C1136.79 145.615 1133.94 144.311 1131.09 143.008C1131.09 143.008 1130.6 143.143 1130.14 142.58C1129.03 141.812 1128.4 141.606 1127.76 141.401C1127.76 141.401 1127.32 141.553 1127.09 140.942C1124.59 140.732 1122.31 141.133 1120.03 141.534C1120.03 141.534 1120.05 141.42 1120.18 140.942C1119.64 139.684 1118.96 138.904 1118.28 138.124C1113.15 131.655 1108.02 125.185 1102.89 118.715C1103.47 117.985 1104.06 117.254 1104.65 116.523C1107.32 117.707 1110.12 118.661 1112.64 120.113C1127.07 128.439 1141.22 137.29 1155.88 145.179C1171.68 153.679 1174.03 158.58 1172.68 176.906C1171.87 187.819 1172.57 199.059 1174.28 209.885C1176.26 222.341 1168.01 228.64 1161.07 235.885C1158.86 238.197 1155.34 239.26 1151.15 241.004C1138.46 242.58 1127.07 244.2 1115.62 245.341C1114 245.503 1112.14 243.344 1110.38 242.259C1111.92 239.773 1113.46 237.286 1115 234.8C1114.33 234.297 1113.66 233.794 1112.99 233.291C1081.25 244.53 1061.2 266.02 1056.69 301.1C1050.96 296.259 1050.55 301.039 1047.32 271.864C1032.69 275.102 1024.64 285.56 1017.23 300.322C1014.15 288.361 1010.58 278.744 1009.37 268.84C1007.4 252.668 1005.9 236.287 1006.24 220.037C1006.49 208.369 1009.92 196.741 1012.31 185.172C1012.68 183.367 1015.04 181.971 1016.48 180.386C1017.84 181.759 1019.2 183.135 1020.56 184.504C1026.75 190.709 1032.94 196.911 1039.95 203.771C1041.72 204.562 1042.68 204.696 1043.63 204.83C1043.63 204.83 1043.58 204.932 1043.56 205.377C1044.1 206.076 1044.65 206.331 1045.21 206.586C1045.21 206.586 1045.09 206.608 1045.25 207.021C1046.02 207.717 1046.62 208.001 1047.23 208.284C1047.23 208.284 1047.64 208.142 1047.99 208.718C1048.93 209.47 1049.51 209.645 1050.1 209.821C1050.1 209.821 1049.99 209.859 1050.13 210.298C1050.91 211.005 1051.54 211.272 1052.18 211.538C1052.18 211.538 1052.56 211.384 1052.89 211.968C1053.81 212.73 1054.41 212.907 1055 213.084C1055 213.084 1054.89 213.122 1055.01 213.561C1055.76 214.268 1056.38 214.534 1057 214.8C1057 214.8 1057.47 214.673 1057.92 215.241C1059.02 216.015 1059.66 216.221 1060.3 216.427C1060.3 216.427 1060.75 216.288 1061.19 216.868C1062.29 217.656 1062.94 217.863 1063.6 218.071C1063.6 218.071 1063.98 217.921 1064.4 218.501C1065.48 219.286 1066.14 219.491 1066.8 219.695C1066.8 219.695 1067.33 219.572 1067.8 220.125C1069.19 220.902 1070.11 221.126 1071.02 221.35C1075.04 222.07 1079.05 222.79 1083.02 223.501C1080.14 213.939 1077.48 205.102 1074.82 196.265C1075.61 195.732 1076.41 195.198 1077.2 194.665C1081.97 197.518 1086.74 200.372 1092.53 203.795C1104.98 208.432 1116.49 209.597 1128.14 205.307C1139.29 201.647 1133.53 212.407 1138.08 215.143C1145.87 209.973 1148.92 200.791 1150.98 191.329C1151.41 189.352 1149.02 186.626 1147.64 184.422C1144.84 179.94 1136.53 178.042 1141.69 169.42C1142.61 168.269 1142.86 167.832 1143.02 167.35C1143.02 167.35 1142.99 167.459 1143.64 167.589C1148.23 167.048 1152.17 166.377 1156.11 165.706C1156.11 165.706 1155.96 165.873 1156.45 165.909C1160.27 163.497 1159.71 161.905 1155.86 161.035C1155.86 161.035 1156 160.975 1155.95 160.58C1155.37 159.916 1154.84 159.646 1154.31 159.376C1154.31 159.376 1154.42 159.366 1154.38 158.936C1153.78 158.258 1153.23 158.009 1152.67 157.76C1152.67 157.76 1152.79 157.738 1152.75 157.304C1152.15 156.625 1151.6 156.381 1151.04 156.136C1151.04 156.136 1151.15 156.107 1151.14 155.706C1150.66 154.951 1150.19 154.598 1149.72 154.244ZM1164.51 191.316C1164.3 189.727 1164.09 188.137 1163.88 186.548C1163.48 186.502 1163.07 186.455 1162.66 186.409C1161.74 192.34 1160.83 198.27 1159.92 204.201C1161.8 204.363 1163.68 204.526 1166.04 204.73C1165.79 199.858 1165.59 196.1 1164.51 191.316Z",
    fill: "url(#paint2_linear_477_18467)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.61 367.751C1009.09 356.753 1015.57 345.755 1022.81 333.944C1024.2 331.037 1024.82 328.943 1025.45 326.848C1025.45 326.848 1025.34 326.309 1025.89 325.921C1026.65 324.981 1026.85 324.431 1027.06 323.881C1027.06 323.881 1027.02 324.049 1027.63 324.011C1035.39 326.049 1030.2 332.029 1031.99 335.8C1031.52 351.526 1026.63 366.219 1020.74 380.515C1014.47 395.71 1006.15 409.781 993.418 421.939C992.053 422.812 991.61 423.253 991.168 423.694C991.168 423.694 991.191 423.554 990.831 423.699C990.17 424.342 989.869 424.84 989.568 425.337C989.568 425.337 989.574 425.214 989.183 425.319C988.516 425.941 988.239 426.457 987.962 426.973C987.962 426.973 988.002 426.863 987.377 426.74C985.489 424.498 983.527 422.509 983.105 420.234C982.111 414.877 981.852 409.384 981.296 403.945C981.296 403.945 981.422 403.951 981.125 403.833C980.645 403.296 980.417 402.901 980.144 402.532C978.462 371.169 964.263 325.328 955.7 310.854C953.384 332.322 948.938 352.246 938.534 370.971C937.587 364.575 936.778 358.154 935.665 351.787C933.152 337.425 929.448 323.181 928.179 308.718C926.9 294.155 924.834 279.085 930.79 264.909C936.903 250.361 942.3 235.261 950.463 221.898C957.886 209.745 968.603 199.6 977.868 188.57C978.793 188.856 979.719 189.141 980.645 189.427C980.328 193.681 980.012 197.935 978.991 203.113C978.659 219.535 979.031 235.032 979.404 250.529C982.839 264.451 986.839 278.266 989.524 292.331C991.507 302.721 991.775 313.438 992.74 325.525C992.75 341.034 992.731 355.028 992.996 369.016C993.042 371.443 994.291 373.848 994.984 376.264C994.984 376.264 995.269 376.115 995.934 375.95C996.929 374.809 997.259 373.834 997.589 372.859C997.589 372.859 997.694 372.976 998.132 372.963C998.799 372.371 999.028 371.792 999.257 371.213C999.257 371.213 999.306 371.331 999.745 371.316C1000.43 370.731 1000.67 370.162 1000.91 369.594C1000.91 369.594 1000.94 369.705 1001.35 369.581C1002.05 368.889 1002.33 368.32 1002.61 367.751Z",
    fill: "url(#paint3_linear_477_18467)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M805.108 281.877C822.694 264.065 831.21 242.05 836.045 217.924C838.969 203.333 841.598 187.939 848.476 175.107C854.494 163.882 866.08 155.543 875.619 146.357C877.984 144.08 881.948 143.459 885.897 142.821C871.367 164.233 865.346 186.977 870.174 214.029C881.285 187.148 886.052 158.327 914.398 143.238C923.969 140.958 932.281 138.357 940.792 137.001C944.328 136.438 948.288 138.533 952.056 139.419C933.543 150.504 925.356 168.788 917.58 187.661C910.108 205.797 901.816 223.606 893.5 241.379C886.236 256.902 873.425 267.625 859.336 278.279C857.923 279.023 857.486 279.459 857.049 279.896C857.049 279.896 856.627 280.138 855.769 280.029C853.557 281.127 852.204 282.334 850.851 283.542C850.851 283.542 850.787 283.422 850.353 283.378C849.547 283.839 849.175 284.345 848.803 284.851C848.803 284.851 848.495 285.083 847.641 284.885C841.519 286.896 836.251 289.105 830.983 291.313C830.983 291.313 830.55 291.563 829.572 291.391C816.501 292.761 804.406 294.303 791.412 295.96C792.559 292.464 793.039 291.003 793.518 289.541C793.518 289.541 793.61 289.678 794.008 289.692C794.774 289.236 795.143 288.766 795.511 288.295C795.511 288.295 795.914 288.056 796.6 287.944C797.694 287.358 798.1 286.886 798.507 286.413C798.507 286.413 798.49 286.528 798.902 286.498C799.687 285.996 800.06 285.524 800.433 285.052C800.433 285.052 800.851 284.813 801.506 284.655C802.586 284.051 803.01 283.606 803.434 283.16C803.434 283.16 803.409 283.306 803.728 283.178C804.4 282.659 804.754 282.268 805.108 281.877Z",
    fill: "url(#paint4_linear_477_18467)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M984.984 89.2903C984.984 89.2903 985.296 89.0502 986.016 89.0629C987.245 88.61 987.753 88.1445 988.261 87.6791C988.261 87.6791 988.6 87.4391 989.278 87.3514C990.358 86.7721 990.759 86.2805 991.16 85.789C991.16 85.789 991.151 85.9053 991.587 85.8743C992.265 85.2812 992.507 84.7191 992.748 84.1571C992.748 84.1571 992.776 84.2705 993.212 84.2391C993.893 83.6471 994.138 83.0864 994.382 82.5258C994.382 82.5258 994.408 82.6392 994.84 82.6054C995.524 82.0133 995.774 81.4552 996.025 80.897C996.025 80.897 996.045 81.0121 996.444 80.8986C997.134 80.2383 997.425 79.6915 997.716 79.1449C1000.03 75.045 1002.34 70.9452 1005.56 66.4165C1006.82 65.5247 1007.16 65.0619 1007.51 64.5991C1007.51 64.5991 1007.49 64.7306 1007.86 64.6391C1008.6 64.1159 1008.98 63.6843 1009.35 63.2527C1009.35 63.2527 1009.79 63.0068 1010.58 63.0831C1011.89 62.4761 1012.4 61.7927 1012.91 61.1092C1011.57 60.7414 1010.24 60.3736 1008.9 60.0057C1008.9 60.0057 1008.96 59.8968 1009.15 59.3643C1011.21 57.8899 1013.24 55.9463 1014.94 56.1979C1019.66 56.895 1024.24 58.5074 1028.87 59.758C1028.87 59.758 1028.77 59.8142 1028.82 60.2316C1029.43 60.9104 1029.97 61.172 1030.52 61.4334C1030.52 61.4334 1030.4 61.4611 1030.52 61.7635C1030.87 62.5683 1031.23 62.9311 1031.73 63.1542C1036.18 70.7867 1040.63 78.4192 1045.01 87.3677C1048.45 95.5197 1038.65 94.5108 1038.67 99.2926C1038.67 99.2926 1038.55 99.1683 1038.13 99.1315C1037.46 99.6516 1037.21 100.208 1036.96 100.765C1036.96 100.765 1037.03 100.683 1036.45 100.476C1034.66 95.469 1033.44 90.6681 1032.22 85.8672C1032.22 85.8672 1031.95 85.315 1032.03 84.4398C1031.48 82.726 1030.85 81.8877 1030.21 81.0494C1030.21 81.0494 1030.34 81.0686 1030.3 80.6654C1029.79 79.8945 1029.32 79.5268 1028.86 79.1589C1028.86 79.1589 1028.61 78.7527 1028.43 78.0586C1027.7 76.9566 1027.14 76.5485 1026.58 76.1405C1026.58 76.1405 1026.15 76.2873 1025.81 75.7021C1024.87 74.942 1024.28 74.7672 1023.69 74.5923C1023.69 74.5923 1023.81 74.6439 1023.78 74.134C1020.58 70.3065 1017.92 70.8755 1015.69 74.6741C1015.69 74.6741 1015.7 74.5533 1015.28 74.5991C1014.6 75.1964 1014.34 75.748 1014.09 76.2996C1014.09 76.2996 1014.07 76.1865 1013.66 76.2525C1012.98 76.8559 1012.71 77.3932 1012.45 77.9305C1012.45 77.9305 1012.44 77.8085 1011.97 77.9774C1011.3 79.1669 1011.1 80.1875 1010.9 81.2081C1010.9 81.2081 1010.82 81.1221 1010.39 81.2253C1009.68 81.9342 1009.41 82.5398 1009.13 83.1453C1007.4 85.5808 1005.66 88.0163 1002.97 90.7387C1001.59 91.4622 1001.16 91.8987 1000.74 92.3353C1000.74 92.3353 1000.33 92.5828 999.341 92.4229C993.902 91.2494 988.091 96.3402 984.984 89.2903Z",
    fill: "url(#paint5_linear_477_18467)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M968.711 102.28C968.711 102.28 969.349 102.2 970.024 102.732C972.47 104.43 974.239 105.597 976.739 107.246C964.764 108.91 954.259 110.369 943.755 111.828C943.755 111.828 943.247 112.11 942.21 111.94C935.521 113.017 929.869 114.264 924.216 115.511C924.216 115.511 924.119 115.313 924.078 115.579C923.589 115.986 923.21 116.234 922.9 116.588C919.9 115.84 911.551 122.175 916.498 110.619C917.097 109.338 917.38 108.963 917.762 108.663C917.762 108.663 917.726 108.835 918.153 108.53C918.841 107.114 919.102 106.003 919.363 104.891C919.363 104.891 919.193 104.531 919.782 104.213C920.543 103.298 920.716 102.7 920.888 102.102C920.888 102.102 920.936 102.216 921.37 102.187C922.051 101.596 922.297 101.034 922.543 100.473C922.543 100.473 922.57 100.585 922.996 100.536C923.675 99.9386 923.929 99.3907 924.182 98.8429C924.182 98.8429 924.205 98.9554 924.63 98.9055C925.308 98.3072 925.56 97.7588 925.813 97.2104C925.813 97.2104 925.837 97.3303 926.361 97.3937C928.164 96.2678 929.443 95.0782 930.722 93.8887C930.722 93.8887 930.742 94.0172 931.259 94.0624C933.056 92.9397 934.335 91.7717 935.614 90.6038C935.614 90.6038 935.667 90.754 936.031 90.6999C936.782 90.2174 937.169 89.7889 937.556 89.3604C937.556 89.3604 937.963 89.1114 938.799 89.2361C941.099 88.2634 942.564 87.1659 944.028 86.0684C944.028 86.0684 944.466 85.8236 945.401 85.9938C949.456 86.485 954.193 84.2739 953.425 90.6821C952.761 91.2118 952.096 91.7415 950.51 92.6009C949.344 93.9093 949.1 94.888 948.856 95.8666C948.856 95.8666 948.746 95.7562 948.304 95.7609C947.636 96.3499 947.41 96.934 947.185 97.5182C947.185 97.5182 947.138 97.3992 946.687 97.3981C946.004 97.9788 945.771 98.5607 945.539 99.1425C945.539 99.1425 945.676 98.9902 945.169 98.9719C941.204 101.891 942.134 103.189 946.277 103.071C953.757 102.858 961.234 102.549 968.711 102.28Z",
    fill: "url(#paint6_linear_477_18467)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.97 736.08C1218.73 734.263 1188.2 731.635 1157.63 729.512C1132.47 727.765 1107.27 726.667 1082.09 725.137C1079.01 724.95 1075.99 723.872 1072.91 722.545C1095.7 722.995 1118.52 723.984 1141.33 725.263C1156.82 726.132 1172.33 727.074 1187.77 728.586C1208.1 730.577 1228.37 733.16 1248.97 736.08Z",
    fill: "#896D20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.97 708.728C209.262 710.066 207.555 711.404 205.802 713.368C195.908 702.64 183.81 692.655 182.254 676.196C181.8 671.391 181.776 666.545 181.643 661.002C182.584 663.429 183.618 666.536 184.252 669.723C185.51 676.046 186.547 682.413 187.676 688.762C188.939 688.648 190.202 688.534 191.464 688.419C191.464 681.897 191.066 675.343 191.594 668.864C191.996 663.934 193.577 659.101 195.236 654.689C195.385 664.995 194.9 674.833 194.486 684.675C194.23 690.756 196.054 695.938 200.972 699.912C204.425 702.702 207.646 705.779 210.97 708.728Z",
    fill: "url(#paint7_linear_477_18467)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.61 133.197C1057.61 133.197 1057.13 133.333 1056.56 132.746C1054.87 131.968 1053.76 131.779 1052.65 131.589C1052.65 131.589 1052.23 131.747 1051.8 131.16C1050.7 130.369 1050.04 130.164 1049.37 129.959C1049.37 129.959 1048.99 130.12 1048.96 129.486C1050.94 127.656 1052.94 126.461 1054.94 125.265C1054.94 125.265 1055.44 124.988 1056.3 125.128C1058.03 124.614 1058.89 123.96 1059.75 123.307C1059.75 123.307 1059.75 123.45 1060.13 123.268C1060.85 122.198 1061.18 121.311 1061.51 120.424C1066.16 121.381 1072.65 120.822 1075.01 123.672C1078.13 127.444 1082.86 133.51 1076.18 138.298C1071.78 136.424 1067.91 135.632 1064.04 134.839C1064.04 134.839 1063.64 134.999 1063.07 134.377C1060.87 133.569 1059.24 133.383 1057.61 133.197Z",
    fill: "url(#paint8_linear_477_18467)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M606.726 275.234C589.86 279.283 572.286 283.378 554.244 287.17C571.191 283.005 588.604 279.143 606.726 275.234Z",
    fill: "url(#paint9_linear_477_18467)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M823.899 736.612C824.28 737.27 824.141 738.376 823.606 738.623C813.309 743.367 786.636 737.836 778.99 728.887C788.463 731.544 797.842 735.442 807.597 737.748C812.439 738.893 817.974 737.115 823.899 736.612Z",
    fill: "#896D20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M979.499 249.788C979.031 235.032 978.659 219.535 978.836 203.777C979.456 218.694 979.526 233.871 979.499 249.788Z",
    fill: "url(#paint10_linear_477_18467)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.53 767.577C1248.15 765.282 1263.49 763.112 1279.58 761.105C1270.97 762.883 1261.65 764.672 1252.28 766.045C1246.31 766.917 1240.26 767.171 1233.53 767.577Z",
    fill: "#896D20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.63 335.484C1030.2 332.029 1035.39 326.049 1027.54 323.985C1028.84 319.528 1030.83 315.059 1032.83 310.59C1033.77 310.852 1034.71 311.113 1035.64 311.375C1034.85 319.306 1034.06 327.236 1032.63 335.484Z",
    fill: "url(#paint11_linear_477_18467)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.39 205.223C1116.49 209.597 1104.99 208.432 1093.08 204.035C1103.95 204.184 1115.3 204.662 1127.39 205.223Z",
    fill: "#896D20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1294.91 743.541C1281.73 741.565 1268.55 739.59 1254.81 737.332C1267.34 738.57 1280.42 740.09 1294.2 742.139C1294.9 742.959 1294.91 743.25 1294.91 743.541Z",
    fill: "#896D20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M994.737 375.53C994.291 373.848 993.041 371.443 992.996 369.016C992.731 355.027 992.75 341.034 992.746 326.266C993.376 327.897 994.39 330.299 994.416 332.711C994.57 346.738 994.491 360.768 994.737 375.53Z",
    fill: "url(#paint12_linear_477_18467)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M721.873 210.549C729.958 211.832 738.272 213.684 747.757 215.797C746.039 217.393 744.862 218.486 743.113 219.646C741.912 218.635 741.505 216.877 740.618 216.588C734.502 214.593 728.285 212.904 721.873 210.549Z",
    fill: "#896D20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M981.408 404.707C981.853 409.384 982.112 414.877 983.106 420.234C983.528 422.509 985.49 424.499 987.418 426.783C986.206 428.199 984.327 429.45 981.52 431.321C981.52 421.538 981.52 413.503 981.408 404.707Z",
    fill: "url(#paint13_linear_477_18467)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M822 607.96C824.454 606.056 827.499 604.081 830.545 602.105C831.281 602.997 832.016 603.889 832.752 604.78C831.457 606.844 830.161 608.908 828.301 611.026C828.072 609.618 828.408 608.158 828.907 605.984C826.693 606.652 824.642 607.27 822 607.96Z",
    fill: "#896D20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M368.499 534.112C367.299 536.836 365.611 539.529 363.923 542.222C363.13 541.792 362.338 541.363 361.545 540.933C363.211 537.787 364.877 534.64 367.09 531.369C367.761 532.19 367.886 533.135 368.499 534.112Z",
    fill: "#896D20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M724.367 230.953C720.356 233.772 715.739 236.68 710.492 239.755C714.495 236.962 719.128 234.003 724.367 230.953Z",
    fill: "#896D20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M831.648 291.397C836.251 289.105 841.519 286.896 847.47 284.797C842.873 287.098 837.594 289.289 831.648 291.397Z",
    fill: "url(#paint14_linear_477_18467)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.94 713.23C1058.24 712.069 1053.32 710.343 1048.24 708.061C1052.96 709.224 1057.84 710.945 1062.94 713.23Z",
    fill: "#896D20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M924.924 115.402C929.868 114.262 935.521 113.015 941.923 111.889C936.993 113.105 931.312 114.2 924.924 115.402Z",
    fill: "#896D20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M855.166 737.471C857.954 739.645 857.994 740.726 854.994 741.105C851.196 741.585 847.263 740.999 842.979 740.354C846.72 739.25 850.871 738.665 855.166 737.471Z",
    fill: "#896D20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M734.172 186.941C731.339 189.111 727.91 191.35 723.865 193.571C726.692 191.372 730.134 189.192 734.172 186.941Z",
    fill: "#896D20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M836.196 731.166C834.436 731.765 832.593 731.771 830.055 731.767C830.448 730.159 831.538 728.562 832.628 726.965C833.79 728.168 834.951 729.37 836.196 731.166Z",
    fill: "#896D20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M735.475 263.884C736.726 262.203 738.529 260.429 740.92 258.793C739.681 260.551 737.853 262.171 735.475 263.884Z",
    fill: "url(#paint15_linear_477_18467)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M753.471 247.566C754.17 245.99 755.453 244.327 757.304 242.604C756.599 244.188 755.327 245.833 753.471 247.566Z",
    fill: "url(#paint16_linear_477_18467)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.94 327.133C1024.82 328.943 1024.2 331.037 1023.09 333.409C1023.21 331.596 1023.83 329.507 1024.94 327.133Z",
    fill: "url(#paint17_linear_477_18467)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M375.05 527.951C374.302 529.526 373.055 531.242 371.209 532.857C371.923 531.202 373.237 529.648 375.05 527.951Z",
    fill: "#896D20"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.53 716.488C1067.59 716.316 1065.4 715.619 1063.14 714.328C1065.14 714.478 1067.22 715.221 1069.53 716.488Z",
    fill: "#896D20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M842.639 739.369C841.117 738.624 839.423 737.389 837.744 735.545C839.328 736.25 840.898 737.565 842.639 739.369Z",
    fill: "#896D20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M642.668 459.525C640.893 460.089 638.458 460.703 635.369 461.208C637.146 460.591 639.577 460.083 642.668 459.525Z",
    fill: "url(#paint18_linear_477_18467)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M851.412 283.452C852.205 282.335 853.558 281.127 855.535 279.965C854.763 281.127 853.368 282.245 851.412 283.452Z",
    fill: "url(#paint19_linear_477_18467)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M737.488 222.803C736.681 223.919 735.312 225.126 733.322 226.284C734.11 225.121 735.518 224.007 737.488 222.803Z",
    fill: "#896D20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M742.373 182.053C741.549 183.2 740.156 184.41 738.129 185.541C738.932 184.346 740.368 183.231 742.373 182.053Z",
    fill: "#896D20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M827.3 611.152C827.088 612.61 826.35 614.232 825.041 615.914C825.239 614.422 826.007 612.869 827.3 611.152Z",
    fill: "#896D20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.7 705.232C1042.46 705.592 1040.88 705.432 1038.9 704.805C1040.12 704.463 1041.73 704.587 1043.7 705.232Z",
    fill: "#896D20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M716.18 197.111C715.451 197.703 714.159 198.194 712.363 198.531C713.112 197.922 714.365 197.466 716.18 197.111Z",
    fill: "#896D20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M758.121 242.479C758.373 241.705 759.043 240.732 760.146 239.59C759.899 240.374 759.218 241.328 758.121 242.479Z",
    fill: "url(#paint20_linear_477_18467)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M368.138 531.135C367.826 529.864 368.073 528.391 368.81 526.594C369.098 527.824 368.898 529.38 368.138 531.135Z",
    fill: "#896D20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M398.052 505.24C397.68 506.038 396.86 507.026 395.561 508.175C395.922 507.367 396.763 506.399 398.052 505.24Z",
    fill: "#896D20"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M105.796 441.484C105.499 441.87 104.705 442.356 103.449 442.968C103.758 442.591 104.529 442.088 105.796 441.484Z",
    fill: "#896D20"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.25 745.884C1305.43 746.247 1304.42 746.084 1303.12 745.473C1303.9 745.136 1304.98 745.247 1306.25 745.884Z",
    fill: "url(#paint21_linear_477_18467)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.6 744.4C1300.81 744.709 1299.71 744.507 1298.26 743.847C1299.05 743.555 1300.17 743.721 1301.6 744.4Z",
    fill: "url(#paint22_linear_477_18467)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M815.375 612.872C815.628 612.306 816.409 611.645 817.718 611.105C817.464 611.743 816.684 612.26 815.375 612.872Z",
    fill: "#896D20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M837.79 734.563C837.228 734.304 836.609 733.505 836.08 732.174C836.691 732.435 837.212 733.229 837.79 734.563Z",
    fill: "#896D20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M749.021 179.035C748.671 179.657 747.746 180.175 746.266 180.633C746.623 180.025 747.535 179.479 749.021 179.035Z",
    fill: "#896D20"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M997.067 373.027C997.258 373.834 996.929 374.81 996.074 376.027C995.882 375.245 996.214 374.22 997.067 373.027Z",
    fill: "url(#paint23_linear_477_18467)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M807.95 368.164C807.965 368.598 807.588 369.203 806.932 369.768C806.955 369.265 807.257 368.799 807.95 368.164Z",
    fill: "url(#paint24_linear_477_18467)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M993.105 11.4043C993.375 11.4329 993.399 11.7475 993.192 12.1987C993.132 12.3669 993.029 11.722 993.105 11.4043Z",
    fill: "url(#paint25_linear_477_18467)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M744.44 180.592C744.576 181.165 744.209 181.674 743.353 182.139C743.221 181.572 743.579 181.05 744.44 180.592Z",
    fill: "#896D20"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M988.407 426.868C988.239 426.457 988.515 425.941 989.245 425.324C989.415 425.737 989.133 426.249 988.407 426.868Z",
    fill: "url(#paint26_linear_477_18467)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.17 367.934C1002.33 368.319 1002.05 368.888 1001.3 369.581C1001.13 369.175 1001.43 368.646 1002.17 367.934Z",
    fill: "url(#paint27_linear_477_18467)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.47 369.676C1000.67 370.162 1000.43 370.731 999.685 371.292C999.464 370.776 999.742 370.267 1000.47 369.676Z",
    fill: "url(#paint28_linear_477_18467)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M998.816 371.305C999.027 371.793 998.798 372.372 998.06 372.93C997.826 372.405 998.101 371.9 998.816 371.305Z",
    fill: "url(#paint29_linear_477_18467)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M980.145 402.912C980.418 402.901 980.646 403.296 981.127 403.897C980.904 403.969 980.477 403.707 980.145 402.912Z",
    fill: "url(#paint30_linear_477_18467)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M991.642 423.564C991.61 423.252 992.052 422.811 992.93 422.145C992.95 422.424 992.534 422.93 991.642 423.564Z",
    fill: "url(#paint31_linear_477_18467)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M990.017 425.23C989.87 424.84 990.171 424.342 990.902 423.711C991.043 424.092 990.753 424.607 990.017 425.23Z",
    fill: "url(#paint32_linear_477_18467)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M109.333 438.277C109.469 438.824 109.097 439.329 108.228 439.82C108.095 439.283 108.459 438.76 109.333 438.277Z",
    fill: "#896D20"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M107.391 439.836C107.545 440.237 107.254 440.753 106.504 441.378C106.346 440.975 106.646 440.462 107.391 439.836Z",
    fill: "#896D20"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M399.699 503.646C399.569 503.695 399.128 503.994 398.598 504.784C398.719 504.694 399.012 504.235 399.699 503.646Z",
    fill: "#896D20"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.45 743.497C1294.91 743.248 1294.9 742.957 1294.88 742.23C1295.43 741.997 1295.99 742.202 1296.8 742.836C1296.69 743.329 1296.34 743.391 1295.45 743.497Z",
    fill: "url(#paint33_linear_477_18467)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M394.828 508.387C394.83 508.617 394.411 509.005 393.682 509.687C393.716 509.503 394.061 509.024 394.828 508.387Z",
    fill: "#896D20"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M391.534 511.471C391.699 511.872 391.423 512.453 390.667 513.135C390.489 512.708 390.791 512.179 391.534 511.471Z",
    fill: "#896D20"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M853.98 735.597C854.458 735.391 855.031 735.626 855.6 736.366C855.09 736.593 854.583 736.315 853.98 735.597Z",
    fill: "#896D20"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M825.763 735.037C825.97 735.509 825.737 736.079 825 736.654C824.772 736.151 825.047 735.644 825.763 735.037Z",
    fill: "#896D20"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M802.965 283.289C803.01 283.606 802.586 284.052 801.738 284.72C801.708 284.435 802.103 283.926 802.965 283.289Z",
    fill: "url(#paint34_linear_477_18467)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M849.315 284.897C849.177 284.344 849.549 283.838 850.417 283.348C850.55 283.89 850.188 284.417 849.315 284.897Z",
    fill: "url(#paint35_linear_477_18467)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M799.934 284.992C800.06 285.523 799.687 285.995 798.846 286.484C798.73 285.978 799.082 285.455 799.934 284.992Z",
    fill: "url(#paint36_linear_477_18467)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M798.035 286.541C798.1 286.885 797.694 287.357 796.823 288.016C796.76 287.691 797.161 287.18 798.035 286.541Z",
    fill: "url(#paint37_linear_477_18467)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M852.357 733.945C852.816 733.757 853.376 734.008 853.954 734.747C853.467 734.952 852.963 734.668 852.357 733.945Z",
    fill: "#896D20"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M795.014 288.244C795.143 288.765 794.775 289.236 793.939 289.736C793.819 289.241 794.168 288.717 795.014 288.244Z",
    fill: "url(#paint38_linear_477_18467)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.6 324.008C1026.85 324.431 1026.65 324.982 1026.01 325.673C1025.76 325.254 1025.95 324.695 1026.6 324.008Z",
    fill: "url(#paint39_linear_477_18467)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M335.211 335.352C335.353 335.35 335.742 335.06 336.167 334.277C336.327 334.518 336.078 334.945 335.211 335.352Z",
    fill: "url(#paint40_linear_477_18467)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M331.939 338.722C331.949 338.531 332.353 338.16 332.998 337.455C332.938 337.595 332.636 338.069 331.939 338.722Z",
    fill: "url(#paint41_linear_477_18467)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.95 706.915C1046.55 707.183 1045.89 706.979 1044.99 706.3C1045.4 706.031 1046.04 706.237 1046.95 706.915Z",
    fill: "#896D20"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M376.762 526.266C376.969 526.738 376.736 527.31 375.998 527.882C375.77 527.376 376.046 526.87 376.762 526.266Z",
    fill: "#896D20"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M370.248 532.799C370.437 533.246 370.187 533.797 369.45 534.385C369.245 533.915 369.526 533.409 370.248 532.799Z",
    fill: "#896D20"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M824.117 616.002C824.401 616.429 824.208 616.981 823.591 617.707C823.324 617.296 823.482 616.711 824.117 616.002Z",
    fill: "#896D20"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M818.617 611.179C818.416 610.716 818.655 610.152 819.391 609.572C819.612 610.063 819.335 610.571 818.617 611.179Z",
    fill: "#896D20"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M381.66 521.371C381.866 521.846 381.632 522.42 380.892 522.989C380.664 522.479 380.942 521.975 381.66 521.371Z",
    fill: "#896D20"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M827.399 733.406C827.604 733.881 827.369 734.453 826.63 735.023C826.403 734.514 826.681 734.01 827.399 733.406Z",
    fill: "#896D20"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M850.723 732.312C851.168 732.126 851.717 732.383 852.309 733.12C851.844 733.318 851.335 733.036 850.723 732.312Z",
    fill: "#896D20"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M829.043 731.775C829.243 732.251 828.999 732.82 828.256 733.39C828.038 732.883 828.319 732.376 829.043 731.775Z",
    fill: "#896D20"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M849 729.921C849.468 729.858 849.952 730.394 850.594 731.449C850.174 731.485 849.595 731.002 849 729.921Z",
    fill: "#896D20"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M389.846 513.225C390.032 513.671 389.777 514.22 389.039 514.808C388.839 514.341 389.122 513.834 389.846 513.225Z",
    fill: "#896D20"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M388.204 514.85C388.4 515.313 388.152 515.873 387.413 516.452C387.201 515.963 387.481 515.455 388.204 514.85Z",
    fill: "#896D20"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M386.567 516.48C386.767 516.952 386.526 517.521 385.786 518.092C385.566 517.589 385.847 517.083 386.567 516.48Z",
    fill: "#896D20"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M384.926 518.109C385.132 518.585 384.898 519.159 384.158 519.727C383.93 519.217 384.208 518.712 384.926 518.109Z",
    fill: "#896D20"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.85 721.529C1072.45 721.686 1071.93 721.388 1071.29 720.607C1071.69 720.442 1072.21 720.758 1072.85 721.529Z",
    fill: "#896D20"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M383.293 519.74C383.498 520.215 383.265 520.789 382.525 521.358C382.297 520.849 382.575 520.344 383.293 519.74Z",
    fill: "#896D20"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.03 718.341C1070.56 718.466 1070.14 718.141 1069.66 717.408C1070.09 717.296 1070.59 717.594 1071.03 718.341Z",
    fill: "#896D20"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M380.028 523.002C380.234 523.475 380 524.048 379.261 524.619C379.034 524.112 379.311 523.607 380.028 523.002Z",
    fill: "#896D20"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M369.379 526.289C369.55 526.32 369.859 526.02 370.154 525.225C370.518 525.553 370.31 525.962 369.379 526.289Z",
    fill: "#896D20"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M378.397 524.633C378.602 525.109 378.368 525.684 377.628 526.252C377.401 525.74 377.679 525.235 378.397 524.633Z",
    fill: "#896D20"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M820.235 609.536C820.054 609.103 820.314 608.562 821.051 607.961C821.244 608.41 820.96 608.918 820.235 609.536Z",
    fill: "#896D20"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M736.308 185.482C736.44 186.033 736.063 186.533 735.194 187.016C735.068 186.477 735.434 185.955 736.308 185.482Z",
    fill: "#896D20"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M711.413 198.475C711.98 198.738 712.071 199.129 712.09 200.12C711.657 200.014 711.296 199.308 711.413 198.475Z",
    fill: "#896D20"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M712.033 201.951C712.589 201.817 713.09 202.183 713.564 203.036C713.018 203.165 712.498 202.808 712.033 201.951Z",
    fill: "#896D20"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M713.562 203.885C714.033 203.681 714.603 203.917 715.178 204.654C714.676 204.878 714.168 204.601 713.562 203.885Z",
    fill: "#896D20"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M715.197 205.513C715.677 205.31 716.254 205.545 716.818 206.286C716.302 206.512 715.798 206.232 715.197 205.513Z",
    fill: "#896D20"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M716.865 207.21C717.323 206.886 717.913 207.046 718.664 207.676C718.216 207.996 717.607 207.845 716.865 207.21Z",
    fill: "#896D20"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M727.08 270.242C727.097 270.056 727.504 269.677 728.164 268.967C728.102 269.107 727.786 269.578 727.08 270.242Z",
    fill: "url(#paint42_linear_477_18467)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M726.447 229.539C726.573 230.059 726.203 230.527 725.366 231.024C725.249 230.53 725.599 230.009 726.447 229.539Z",
    fill: "#896D20"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M751.641 249.079C751.484 248.676 751.772 248.165 752.504 247.545C752.66 247.948 752.373 248.46 751.641 249.079Z",
    fill: "url(#paint43_linear_477_18467)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M750.018 250.716C749.851 250.299 750.129 249.778 750.862 249.166C751.033 249.587 750.748 250.1 750.018 250.716Z",
    fill: "url(#paint44_linear_477_18467)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M748.389 252.345C748.218 251.925 748.492 251.401 749.225 250.793C749.4 251.219 749.117 251.731 748.389 252.345Z",
    fill: "url(#paint45_linear_477_18467)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M746.763 253.98C746.581 253.541 746.841 253.002 747.576 252.406C747.768 252.86 747.487 253.37 746.763 253.98Z",
    fill: "url(#paint46_linear_477_18467)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M745.144 255.615C744.949 255.163 745.198 254.612 745.932 254.025C746.141 254.499 745.864 255.008 745.144 255.615Z",
    fill: "url(#paint47_linear_477_18467)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M743.517 257.249C743.317 256.787 743.558 256.227 744.292 255.648C744.51 256.137 744.234 256.644 743.517 257.249Z",
    fill: "url(#paint48_linear_477_18467)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M741.887 258.882C741.683 258.41 741.919 257.843 742.655 257.271C742.879 257.773 742.603 258.279 741.887 258.882Z",
    fill: "url(#paint49_linear_477_18467)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M733.696 265.392C733.528 264.978 733.802 264.456 734.535 263.844C734.708 264.264 734.423 264.774 733.696 265.392Z",
    fill: "url(#paint50_linear_477_18467)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M732.007 267.202C731.835 266.802 732.103 266.2 732.864 265.492C733.053 265.924 732.75 266.462 732.007 267.202Z",
    fill: "url(#paint51_linear_477_18467)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M729.436 227.816C729.527 228.189 729.146 228.693 728.267 229.349C728.167 228.983 728.565 228.465 729.436 227.816Z",
    fill: "#896D20"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M723.959 273.192C723.865 272.79 724.261 272.532 725.005 272.156C725.097 272.428 724.795 272.86 723.959 273.192Z",
    fill: "url(#paint52_linear_477_18467)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M857.568 279.951C857.486 279.459 857.924 279.022 858.837 278.484C858.904 278.925 858.496 279.466 857.568 279.951Z",
    fill: "url(#paint53_linear_477_18467)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M804.645 281.814C804.753 282.267 804.399 282.658 803.654 283.165C803.57 282.772 803.877 282.263 804.645 281.814Z",
    fill: "url(#paint54_linear_477_18467)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M331.239 283.295C331.236 283.325 330.88 283.484 330.343 283.655C330.148 283.648 330.872 283.403 331.239 283.295Z",
    fill: "url(#paint55_linear_477_18467)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M719.885 208.667C720.24 208.527 720.846 208.809 721.608 209.568C721.222 209.726 720.679 209.408 719.885 208.667Z",
    fill: "#896D20"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M741.139 219.752C741.271 220.291 740.906 220.77 740.069 221.252C739.946 220.735 740.295 220.214 741.139 219.752Z",
    fill: "#896D20"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M739.254 221.275C739.429 221.7 739.162 222.233 738.427 222.839C738.244 222.402 738.528 221.893 739.254 221.275Z",
    fill: "#896D20"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M731.387 226.264C731.521 226.844 731.152 227.356 730.293 227.812C730.163 227.236 730.523 226.716 731.387 226.264Z",
    fill: "#896D20"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M477.24 715.827C527.903 715.337 578.932 715.509 629.962 715.561C673.124 715.606 716.286 715.513 760.216 715.42C758.223 715.978 755.464 717.133 752.703 717.139C664.195 717.306 575.686 717.372 487.177 717.392C483.987 717.393 480.797 716.77 477.24 715.827Z",
    fill: "url(#paint56_linear_477_18467)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M722.487 552.361C721.999 553.387 720.909 555.495 719.711 555.558C705.551 556.31 691.378 556.853 677.203 557.246C669.367 557.463 661.512 557.525 653.68 557.247C640.597 556.783 627.525 555.99 614.086 554.717C624.693 554.385 635.672 555.108 646.631 554.871C671.704 554.328 696.767 553.315 722.487 552.361Z",
    fill: "#896D20"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M846.369 715.955C868.638 716.205 891.359 716.875 914.474 718.178C910.943 718.913 907.018 719.016 901.84 719.022C900.234 718.942 899.881 718.96 899.528 718.978C885.023 718.85 870.516 718.844 856.016 718.498C852.936 718.425 849.885 717.116 846.369 715.955Z",
    fill: "#896D20"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M607.032 553.158C592.327 551.465 577.372 549.258 562.09 546.496C576.769 548.176 591.776 550.41 607.032 553.158Z",
    fill: "url(#paint57_linear_477_18467)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M554.91 545.027C542.566 542.363 529.996 539.187 516.776 536.093C516.726 535.389 517.543 533.828 517.896 533.926C530.185 537.359 542.431 540.947 554.91 545.027Z",
    fill: "url(#paint58_linear_477_18467)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M745.525 617.276C745.461 599.06 745.943 580.569 746.308 561.32C746.152 579.375 746.111 598.188 745.525 617.276Z",
    fill: "#896D20"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M916.559 719.369C931.846 718.881 947.693 718.784 964.308 718.666C963.95 719.254 962.819 720.4 961.698 720.391C946.837 720.276 931.977 719.999 916.559 719.369Z",
    fill: "url(#paint59_linear_477_18467)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M445.774 620.818C441.205 623.633 435.984 626.389 430.133 629.258C434.709 626.5 439.915 623.63 445.774 620.818Z",
    fill: "#896D20"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M761.385 715.286C760.907 712.726 761.009 709.957 761.217 706.5C761.538 708.901 761.751 711.989 761.385 715.286Z",
    fill: "url(#paint60_linear_477_18467)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M437.799 683.291C439.347 683.519 440.942 684.357 442.848 685.682C441.387 685.412 439.617 684.657 437.799 683.291Z",
    fill: "#896D20"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M432.898 679.982C434.405 680.183 435.952 680.97 437.672 682.275C436.21 682.052 434.575 681.31 432.898 679.982Z",
    fill: "#896D20"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M458.878 612.645C458.075 613.844 456.644 614.965 454.643 616.156C455.465 615.006 456.857 613.786 458.878 612.645Z",
    fill: "#896D20"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M453.571 616.01C452.864 617.189 451.572 618.27 449.732 619.414C450.452 618.288 451.719 617.1 453.571 616.01Z",
    fill: "#896D20"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M963.334 715.179C962.451 714.383 961.548 713.05 960.582 711.211C961.45 712.017 962.382 713.329 963.334 715.179Z",
    fill: "url(#paint61_linear_477_18467)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M125.166 438.14C125.149 436.639 125.781 435.13 126.882 433.432C126.84 434.872 126.327 436.502 125.166 438.14Z",
    fill: "url(#paint62_linear_477_18467)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M426.052 630.715C426.202 631.296 425.945 631.7 425.149 631.986C425.128 631.534 425.473 631.091 426.052 630.715Z",
    fill: "#896D20"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M419.713 667.192C420.106 666.926 420.681 667.071 421.38 667.685C420.967 667.97 420.43 667.786 419.713 667.192Z",
    fill: "#896D20"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M445.928 688.082C446.403 687.992 446.905 688.337 447.326 689.16C446.814 689.263 446.384 688.89 445.928 688.082Z",
    fill: "#896D20"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M444.049 686.726C444.51 686.418 445.121 686.583 445.858 687.236C445.389 687.548 444.794 687.373 444.049 686.726Z",
    fill: "#896D20"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M431.238 678.344C431.718 678.136 432.228 678.416 432.838 679.14C432.381 679.333 431.825 679.082 431.238 678.344Z",
    fill: "#896D20"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M429.6 676.71C430.09 676.504 430.592 676.789 431.198 677.512C430.738 677.7 430.175 677.45 429.6 676.71Z",
    fill: "#896D20"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M427.951 675.093C428.474 674.862 428.979 675.141 429.579 675.859C429.093 676.067 428.513 675.834 427.951 675.093Z",
    fill: "#896D20"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M426.316 673.464C426.839 673.23 427.344 673.508 427.946 674.223C427.462 674.432 426.88 674.203 426.316 673.464Z",
    fill: "#896D20"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M424.684 671.833C425.206 671.599 425.711 671.876 426.314 672.591C425.83 672.801 425.248 672.572 424.684 671.833Z",
    fill: "#896D20"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M423.057 670.206C423.564 669.974 424.072 670.248 424.679 670.961C424.205 671.171 423.631 670.941 423.057 670.206Z",
    fill: "#896D20"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M421.434 668.563C421.924 668.348 422.43 668.627 423.038 669.345C422.577 669.542 422.013 669.3 421.434 668.563Z",
    fill: "#896D20"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M466.929 606.365C467.053 606.74 466.718 607.259 465.925 607.896C465.802 607.513 466.136 607.011 466.929 606.365Z",
    fill: "#896D20"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M448.77 619.332C448.897 619.874 448.537 620.396 447.667 620.861C447.533 620.306 447.908 619.809 448.77 619.332Z",
    fill: "#896D20"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M465.1 607.951C465.308 608.426 465.028 608.934 464.307 609.544C464.114 609.092 464.363 608.539 465.1 607.951Z",
    fill: "#896D20"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M461.829 611.168C461.959 611.73 461.595 612.249 460.722 612.71C460.587 612.143 460.961 611.634 461.829 611.168Z",
    fill: "#896D20"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M463.46 609.578C463.677 610.061 463.398 610.566 462.681 611.177C462.484 610.721 462.725 610.161 463.46 609.578Z",
    fill: "#896D20"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M899.766 719.161C899.883 718.961 900.236 718.943 901.117 718.986C901.097 719.145 900.549 719.244 899.766 719.161Z",
    fill: "url(#paint63_linear_477_18467)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M965.172 718.617C964.963 718.506 965.001 718.229 964.984 717.535C965.092 717.562 965.255 718.006 965.172 718.617Z",
    fill: "url(#paint64_linear_477_18467)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M964.877 716.879C964.53 717.003 964.006 716.714 963.342 715.98C963.701 715.845 964.2 716.156 964.877 716.879Z",
    fill: "url(#paint65_linear_477_18467)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_477_18467",
    x1: 653.222,
    y1: 280.152,
    x2: 653.222,
    y2: 784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_477_18467",
    x1: 813.813,
    y1: 0,
    x2: 813.813,
    y2: 302.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_477_18467",
    x1: 1090.39,
    y1: 116.523,
    x2: 1090.39,
    y2: 301.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_477_18467",
    x1: 979.413,
    y1: 188.57,
    x2: 979.413,
    y2: 426.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_477_18467",
    x1: 871.734,
    y1: 136.906,
    x2: 871.734,
    y2: 295.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_477_18467",
    x1: 1015.36,
    y1: 56.1758,
    x2: 1015.36,
    y2: 100.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_477_18467",
    x1: 945.852,
    y1: 85.9336,
    x2: 945.852,
    y2: 117.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_477_18467",
    x1: 196.306,
    y1: 654.689,
    x2: 196.306,
    y2: 713.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_477_18467",
    x1: 1064.26,
    y1: 120.424,
    x2: 1064.26,
    y2: 138.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_477_18467",
    x1: 580.485,
    y1: 275.234,
    x2: 580.485,
    y2: 287.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_477_18467",
    x1: 979.147,
    y1: 203.777,
    x2: 979.147,
    y2: 249.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_477_18467",
    x1: 1031.59,
    y1: 310.59,
    x2: 1031.59,
    y2: 335.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_477_18467",
    x1: 993.742,
    y1: 326.266,
    x2: 993.742,
    y2: 375.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_477_18467",
    x1: 984.413,
    y1: 404.707,
    x2: 984.413,
    y2: 431.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_477_18467",
    x1: 839.559,
    y1: 284.797,
    x2: 839.559,
    y2: 291.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_477_18467",
    x1: 738.197,
    y1: 258.793,
    x2: 738.197,
    y2: 263.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_477_18467",
    x1: 755.387,
    y1: 242.604,
    x2: 755.387,
    y2: 247.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_477_18467",
    x1: 1024.02,
    y1: 327.133,
    x2: 1024.02,
    y2: 333.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_477_18467",
    x1: 639.019,
    y1: 459.525,
    x2: 639.019,
    y2: 461.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_477_18467",
    x1: 853.473,
    y1: 279.965,
    x2: 853.473,
    y2: 283.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_477_18467",
    x1: 759.133,
    y1: 239.59,
    x2: 759.133,
    y2: 242.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_477_18467",
    x1: 1304.69,
    y1: 745.287,
    x2: 1304.69,
    y2: 746.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_477_18467",
    x1: 1299.93,
    y1: 743.709,
    x2: 1299.93,
    y2: 744.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_477_18467",
    x1: 996.571,
    y1: 373.027,
    x2: 996.571,
    y2: 376.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_477_18467",
    x1: 807.441,
    y1: 368.164,
    x2: 807.441,
    y2: 369.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_477_18467",
    x1: 993.204,
    y1: 11.4043,
    x2: 993.204,
    y2: 12.2262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_477_18467",
    x1: 988.826,
    y1: 425.324,
    x2: 988.826,
    y2: 426.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_477_18467",
    x1: 1001.73,
    y1: 367.934,
    x2: 1001.73,
    y2: 369.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_477_18467",
    x1: 1000.07,
    y1: 369.676,
    x2: 1000.07,
    y2: 371.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_477_18467",
    x1: 998.435,
    y1: 371.305,
    x2: 998.435,
    y2: 372.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_477_18467",
    x1: 980.636,
    y1: 402.912,
    x2: 980.636,
    y2: 403.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_477_18467",
    x1: 992.286,
    y1: 422.145,
    x2: 992.286,
    y2: 423.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_477_18467",
    x1: 990.458,
    y1: 423.711,
    x2: 990.458,
    y2: 425.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_477_18467",
    x1: 1295.84,
    y1: 742.137,
    x2: 1295.84,
    y2: 743.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_477_18467",
    x1: 802.352,
    y1: 283.289,
    x2: 802.352,
    y2: 284.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_477_18467",
    x1: 849.865,
    y1: 283.348,
    x2: 849.865,
    y2: 284.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_477_18467",
    x1: 799.391,
    y1: 284.992,
    x2: 799.391,
    y2: 286.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_477_18467",
    x1: 797.429,
    y1: 286.541,
    x2: 797.429,
    y2: 288.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_477_18467",
    x1: 794.477,
    y1: 288.244,
    x2: 794.477,
    y2: 289.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_477_18467",
    x1: 1026.3,
    y1: 324.008,
    x2: 1026.3,
    y2: 325.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_477_18467",
    x1: 335.712,
    y1: 334.277,
    x2: 335.712,
    y2: 335.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_477_18467",
    x1: 332.469,
    y1: 337.455,
    x2: 332.469,
    y2: 338.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_477_18467",
    x1: 727.622,
    y1: 268.967,
    x2: 727.622,
    y2: 270.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_477_18467",
    x1: 752.072,
    y1: 247.545,
    x2: 752.072,
    y2: 249.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_477_18467",
    x1: 750.44,
    y1: 249.166,
    x2: 750.44,
    y2: 250.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_477_18467",
    x1: 748.808,
    y1: 250.793,
    x2: 748.808,
    y2: 252.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_477_18467",
    x1: 747.171,
    y1: 252.406,
    x2: 747.171,
    y2: 253.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_477_18467",
    x1: 745.54,
    y1: 254.025,
    x2: 745.54,
    y2: 255.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_477_18467",
    x1: 743.907,
    y1: 255.648,
    x2: 743.907,
    y2: 257.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_477_18467",
    x1: 742.274,
    y1: 257.271,
    x2: 742.274,
    y2: 258.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_477_18467",
    x1: 734.116,
    y1: 263.844,
    x2: 734.116,
    y2: 265.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_477_18467",
    x1: 732.438,
    y1: 265.492,
    x2: 732.438,
    y2: 267.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_477_18467",
    x1: 724.483,
    y1: 272.156,
    x2: 724.483,
    y2: 273.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_477_18467",
    x1: 858.201,
    y1: 278.484,
    x2: 858.201,
    y2: 279.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_477_18467",
    x1: 804.152,
    y1: 281.814,
    x2: 804.152,
    y2: 283.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_477_18467",
    x1: 330.775,
    y1: 283.295,
    x2: 330.775,
    y2: 283.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_477_18467",
    x1: 618.728,
    y1: 715.42,
    x2: 618.728,
    y2: 717.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_477_18467",
    x1: 584.561,
    y1: 546.496,
    x2: 584.561,
    y2: 553.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_477_18467",
    x1: 535.842,
    y1: 533.922,
    x2: 535.842,
    y2: 545.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_477_18467",
    x1: 940.433,
    y1: 718.666,
    x2: 940.433,
    y2: 720.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_477_18467",
    x1: 761.31,
    y1: 706.5,
    x2: 761.31,
    y2: 715.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_477_18467",
    x1: 961.958,
    y1: 711.211,
    x2: 961.958,
    y2: 715.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_477_18467",
    x1: 126.024,
    y1: 433.432,
    x2: 126.024,
    y2: 438.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_477_18467",
    x1: 900.441,
    y1: 718.967,
    x2: 900.441,
    y2: 719.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_477_18467",
    x1: 965.09,
    y1: 717.535,
    x2: 965.09,
    y2: 718.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_477_18467",
    x1: 964.109,
    y1: 715.949,
    x2: 964.109,
    y2: 716.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FFE5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#896C1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoldHeader);
export default __webpack_public_path__ + "static/media/logo-gold-header.0e32a497a47e7521d3d915f67c408c24.svg";
export { ForwardRef as ReactComponent };